<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{ "organization.create.section_4.customer_hub_section_1.authentication_details" |
              translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div fxFlex="100">
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('axConfigDetailsUserName')"
                      formControlName="axConfigDetailsUserName"
                      id="axConfigDetailsUserName"
                      matInput
                      [placeholder]="
                    'organization.create.section_4.customer_hub_section_1.user_name' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('axConfigDetailsPassword')"
                      formControlName="axConfigDetailsPassword"
                      id="axConfigDetailsPassword"
                      type="password"
                      matInput
                      [placeholder]="
                    'organization.create.section_4.customer_hub_section_1.password' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('axConfigDetailsDatabase')"
                      formControlName="axConfigDetailsDatabase"
                      id="axConfigDetailsDatabase"
                      matInput
                      [placeholder]="
                    'organization.create.section_4.customer_hub_section_1.database' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('axConfigDetailsServer')"
                      formControlName="axConfigDetailsServer"
                      id="axConfigDetailsServer"
                      matInput
                      [placeholder]="
                    'organization.create.section_4.customer_hub_section_1.server' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="20px grid">
                <div fxFlex="50" *ngIf="!salesExport">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('axConfigDetailsCustomerTable')"
                      formControlName="axConfigDetailsCustomerTable"
                      id="axConfigDetailsCustomerTable"
                      matInput
                      [placeholder]="
                    'organization.create.section_4.customer_hub_section_1.customer_table' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50" *ngIf="salesExport">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('axConfigDetailsPaymentTable')"
                      formControlName="axConfigDetailsPaymentTable"
                      id="axConfigDetailsPaymentTable"
                      matInput
                      [placeholder]="
                    'organization.create.section_4.customer_hub_section_1.payment_table' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50" *ngIf="salesExport">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('axConfigDetailsHeaderTable')"
                      formControlName="axConfigDetailsHeaderTable"
                      id="axConfigDetailsHeaderTable"
                      matInput
                      [placeholder]="
                    'organization.create.section_4.customer_hub_section_1.header_table' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="20px grid" *ngIf="salesExport">
                <div fxFlex="50" *ngIf="!salesExport">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('axConfigDetailsHeaderTable')"
                      formControlName="axConfigDetailsHeaderTable"
                      id="axConfigDetailsHeaderTable"
                      matInput
                      [placeholder]="
                    'organization.create.section_4.customer_hub_section_1.header_table' |
                    translate"
                    />
                  </mat-form-field>
                </div>
                <div fxFlex="50">
                  <mat-form-field class="mat-block">
                    <input
                      [required]="isRequired('axConfigDetailsOrderTable')"
                      formControlName="axConfigDetailsOrderTable"
                      id="axConfigDetailsOrderTable"
                      matInput
                      [placeholder]="
                    'organization.create.section_4.customer_hub_section_1.order_table' |
                    translate"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>
